// Runtime configuration from public/config.js, written by the web container from API_URL (SPEC §9.1).

interface RuntimeConfig {
  apiUrl: string;
}

declare global {
  interface Window {
    WEBUNIVERSE_CONFIG?: RuntimeConfig;
  }
}

/** The API base URL, without a trailing slash. */
export function apiBaseUrl(): string {
  const configured: string = window.WEBUNIVERSE_CONFIG?.apiUrl ?? "/api";
  return configured.replace(/\/+$/, "");
}
